import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { FormikSwapList, FormikToggleCheckbox } from '../../../../../components/FormikFields'
import { ModalPanel, Section } from '../../../../../components/ModalSidebar'
import { FORM_FIELDS } from './constants'
import { FormOptionsContext } from './useFormOptions'

const propTypes = {}

function OptionalSettingsPanel() {
  const { m365GroupOptions, securityGroupOptions, distributionGroupOptions, sharedMailboxOptions } =
    useContext(FormOptionsContext)

  return (
    <ModalPanel leftButton="back" rightButton="next">
      <Section title="ENGAGE.OFFBOARD.SECURITY_ACTIONS">
        <FormikToggleCheckbox
          id={FORM_FIELDS.RESET_PASSWORD}
          label={<FormattedMessage id="ENGAGE.RESET_PASSWORD" />}
          className="checkbox-left-aligned auto-z-index mb-1 pt-0"
        />

        <FormikToggleCheckbox
          id={FORM_FIELDS.REVOKE_SESSIONS}
          label={<FormattedMessage id="ENGAGE.SIGN_USER_OUT_OF_ALL_APPS" />}
          className="checkbox-left-aligned auto-z-index mb-1"
        />

        <FormikToggleCheckbox
          id={FORM_FIELDS.DISABLE_USER}
          label={<FormattedMessage id="ENGAGE.BLOCK_USER_FROM_SIGNING_IN" />}
          className="checkbox-left-aligned auto-z-index mb-1"
        />
      </Section>

      {m365GroupOptions?.length ? (
        <Section title="ENGAGE.OFFBOARD.REMOVE_FROM_GROUPS">
          <FormikSwapList
            id={FORM_FIELDS.REMOVE_FROM_M365_GROUPS}
            selectedOptionsTitle="ENGAGE.OFFBOARD.REMOVE_FROM_GROUPS_COLON"
            unselectedOptionsTitle="ENGAGE.OFFBOARD.KEEP_IN_GROUPS"
            options={m365GroupOptions}
          />
        </Section>
      ) : null}

      {securityGroupOptions?.length ? (
        <Section title="ENGAGE.OFFBOARD.REMOVE_FROM_SECURITY_GROUPS">
          <FormikSwapList
            id={FORM_FIELDS.REMOVE_FROM_SECURITY_GROUPS}
            selectedOptionsTitle="ENGAGE.OFFBOARD.REMOVE_FROM_SECURITY_GROUPS_COLON"
            unselectedOptionsTitle="ENGAGE.OFFBOARD.KEEP_IN_SECURITY_GROUPS"
            options={securityGroupOptions}
          />
        </Section>
      ) : null}

      {distributionGroupOptions?.length ? (
        <Section title="ENGAGE.OFFBOARD.REMOVE_FROM_DISTRIBUTION_GROUPS">
          <FormikSwapList
            id={FORM_FIELDS.REMOVE_FROM_DISTRIBUTION_GROUPS}
            selectedOptionsTitle="ENGAGE.OFFBOARD.REMOVE_FROM_DISTRIBUTION_GROUPS_COLON"
            unselectedOptionsTitle="ENGAGE.OFFBOARD.KEEP_IN_DISTRIBUTION_GROUPS"
            options={distributionGroupOptions}
          />
        </Section>
      ) : null}

      {sharedMailboxOptions?.length ? (
        <Section title="ENGAGE.OFFBOARD.REMOVE_FROM_SHARED_MAILBOXES" showSeparatorLine={false}>
          <FormikSwapList
            id={FORM_FIELDS.REMOVE_FROM_SHARED_MAILBOXES}
            selectedOptionsTitle="ENGAGE.OFFBOARD.REMOVE_FROM_SHARED_MAILBOXES_COLON"
            unselectedOptionsTitle="ENGAGE.OFFBOARD.KEEP_IN_SHARED_MAILBOXES"
            options={sharedMailboxOptions}
          />
        </Section>
      ) : null}
    </ModalPanel>
  )
}

OptionalSettingsPanel.propTypes = propTypes

export default OptionalSettingsPanel
